import { getStringEnvironmentVariable } from '../../lib';

export const API_BASE_URL = getStringEnvironmentVariable('REACT_APP_API_BASE_URL');
export const API_KEY = getStringEnvironmentVariable('REACT_APP_API_KEY');
export const BOT_NAME = getStringEnvironmentVariable('REACT_APP_BOT_NAME');
